// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchBarWrapper_searchWrapper__VxxKt"};